module.exports = __webpack_public_path__ + "static/img/s140.f8164163.png";